import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";

import { Status } from "../types";
import { getAppConfigSetting } from "../utils/getAppConfigSetting";
import { GET_MARGIN_CALLS } from "./constants";
import queryKeys from "./queryKeys";

export interface CallAlertData {
  eventType: string;
  eventName: string;
  description: string;
  callAmount: number;
  eventCode: string;
  dueDate: string;
  issueDate: string;
  closedDate: string | null;
  tradeDate: string;
  status: Status;
}

const useGetCallOrAlert = (eventId: string) => {
  const marginCallsApiURL = `${getAppConfigSetting(
    "apiUrl"
  )}${GET_MARGIN_CALLS}`;

  const fetchCallAlert = async () => {
    const { data } = await axios.get(`${marginCallsApiURL}/${eventId}`, {
      withCredentials: true,
    });
    return data as CallAlertData;
  };

  return useQuery<CallAlertData, AxiosError>(
    [queryKeys.getCallOrAlert, eventId],
    fetchCallAlert
  );
};

export default useGetCallOrAlert;
